export default __webpack_public_path__ + "static/media/sbBUSD.488237bc.svg";